<app-header [headerStep]="headerStep" [local]="true"></app-header>
<div class="mb-[3rem]">
  <ng-container *ngIf="customizeOfferVm">
    <div class="md:container md:mx-auto">
      <div *ngIf="iB_CP" class="container-OC flex">
        <div class="panelCPlusLogo-OC mx-5 my-auto flex-grow"></div>
        <div class="mr-5 my-5 text-right flex-1">
          <p class="rate-OC">{{ customizeOfferVm.rate }}</p>
          <p class="textMonth-OC">{{ resource.offercustomization.textMonth }}</p>
        </div>
      </div>

      <div *ngIf="iB_C" class="containerC-OC flex">
        <div class="panelCLogo-OC mx-5 my-auto flex-grow"></div>
        <div class="mr-5 my-5 text-right flex-1">
          <p class="rateC-OC">{{ customizeOfferVm.rate }}</p>
          <p class="textMonthC-OC">{{ resource.offercustomization.textMonth }}</p>
        </div>
      </div>

      <div *ngIf="iB_P" class="container-OC flex">
        <div [ngClass]="productClass" class="mx-5 my-auto flex-grow"></div>
        <div class="mr-5 my-5 text-right flex-1">
          <p class="rate-OC">{{ customizeOfferVm.rate }}</p>
          <p class="textMonth-OC">{{ resource.offercustomization.textMonth }}</p>
        </div>
      </div>

      <div *ngIf="iB_S" class="container-OC flex">
        <div class="panelSLogo-OC mx-5 my-auto flex-grow"></div>
        <div class="mr-5 my-5 text-right flex-1">
          <p class="rate-OC">{{ customizeOfferVm.rate }}</p>
          <p class="textMonth-OC">{{ resource.offercustomization.textMonth }}</p>
        </div>
      </div>
    </div>
    <div
      class="containerOption md:container md:mx-auto md:px-24 px-5 pt-8 pb-7 space-y-3"
      [ngStyle]="{ 'min-height': iB_CP ? '129px' : '89px' }">
      <div class="flex" *ngFor="let option of options">
        <p
          class="pr-3"
          *ngIf="option.optional"
          (click)="deleteOption(option.id)"
          (keydown)="deleteOption(option.id)">
          <span class="trash"></span>
        </p>
        <p class="flex-3 textOption">{{ option.name }}</p>
        <p class="flex-1 textBOption text-right">{{ option.valueShow }}</p>
      </div>
    </div>
    <div class="container mx-auto">
      <app-question [question]="question" [local]="true"></app-question>

      <div *ngIf="!customizeOffer">
        <div class="my-4 space-y-5">
          <button
            pButton
            class="buttonOption p-4"
            [label]="resource.offercustomization.rate5k"
            (click)="selectValueInsured(offerCustomizationEnum.FiveK)"
            [ngClass]="setClassActive(equal5k)"></button>
          <button
            pButton
            class="mx-auto buttonOption p-4"
            [label]="customizeOfferVm.rate10K"
            (click)="selectValueInsured(offerCustomizationEnum.TenK)"
            [ngClass]="setClassActive(equal10k)"></button>
          <button
            pButton
            class="mx-auto buttonOption p-4"
            [label]="customizeOfferVm.rate20K"
            (click)="selectValueInsured(offerCustomizationEnum.TwentyK)"
            [ngClass]="setClassActive(equal20k)"></button>
        </div>

        <div class="mt-6 mb-4">
          <button
            pButton
            class="mx-auto my-4 button-NS width-max iconSideLabel"
            [label]="resource.nextstep.nextStep"
            icon="pi pi-arrow-right"
            iconPos="right"
            (click)="nextStepCO()"></button>
        </div>
      </div>
      <div *ngIf="customizeOffer" class="flex flex-col gap-y-4 my-4">
        <!-- TODO: Composant générique pour gérer l'affichage (idéalement un formArray pour englober) -->
        <!-- Vélos -->
        <div
          class="panelSV width-max flex flex-col"
          [ngClass]="setClassActive(bikeProtect)"
          (click)="
            $event.preventDefault();
            $event.stopPropagation();
            setInputSwitch(offerCustomizationEnum.BP)
          "
          (keydown)="
            $event.preventDefault();
            $event.stopPropagation();
            setInputSwitch(offerCustomizationEnum.BP)
          "
          *ngIf="this.showBikeProtect">
          <div class="flex m-4">
            <div class="flex bg-gray-100 items-center justify-between py-4 px-6 w-full rounded-2xl">
              <p class="textPanelOpt">
                {{ resource.offercustomization.titleBP }}
              </p>
              <p class="textBPanelOpt" [innerHTML]="customizeOfferVm.subtitleBP"></p>
            </div>
          </div>
          <div class="flex m-4 mt-0">
            <!-- INFOS -->
            <div class="flex basis-5/6 gap-y-2 flex-col">
              <p class="italic">{{ resource.infobulle.bikeProtection1 }}</p>
            </div>

            <div class="flex basis-1/6 items-center justify-center flex-col">
              <p-inputSwitch
                [(ngModel)]="bikeProtect"
                (click)="
                  $event.preventDefault();
                  $event.stopPropagation();
                  updateOptionSwitch(offerCustomizationEnum.BP)
                "
                (keydown)="
                  $event.preventDefault();
                  $event.stopPropagation();
                  updateOptionSwitch(offerCustomizationEnum.BP)
                "></p-inputSwitch>
            </div>
          </div>
        </div>
        <!-- PROTECTION JURIDIQUE -->
        <div
          class="panelSV width-max flex flex-col"
          [ngClass]="setClassActive(juridProtect)"
          (click)="
            $event.preventDefault();
            $event.stopPropagation();
            setInputSwitch(offerCustomizationEnum.JP)
          "
          (keydown)="
            $event.preventDefault();
            $event.stopPropagation();
            setInputSwitch(offerCustomizationEnum.JP)
          "
          *ngIf="
            showPJ &&
            currentFormule.PrimesOptions &&
            currentFormule.PrimesOptions.ProtectionJuridique
          ">
          <div class="flex m-4">
            <div class="flex w-full">
              <div
                class="flex bg-gray-100 items-center justify-between py-4 px-6 w-full rounded-2xl">
                <p class="textPanelOpt">
                  {{ resource.offercustomization.titleJP }}
                </p>
                <p class="textBPanelOpt" [innerHTML]="customizeOfferVm.subtitleJP"></p>
              </div>
            </div>
          </div>
          <div class="flex m-4 mt-0 justify-between">
            <div class="flex basis-5/6 gap-y-2 flex-col">
              @if(path !== pathType.HOUSING && path !== pathType.HOUSING_ETUDIANTE){
              <p class="italic">{{ resource.infobulle.legalProtection2 }}</p>
              } @else {
              <p class="italic">{{ resource.infobulle.legalProtection1 }}</p>
              } @if(path === pathType.HOUSING || path === pathType.HOUSING_ETUDIANTE){
              <p class="italic">{{ this.resource.infobulle.legalProtection2PS }}</p>
              }
            </div>
            <div class="flex flex-col justify-center basis-1/6 items-center">
              <p-inputSwitch
                [(ngModel)]="juridProtect"
                (click)="
                  $event.preventDefault();
                  $event.stopPropagation();
                  updateOptionSwitch(offerCustomizationEnum.JP)
                "
                (keydown)="
                  $event.preventDefault();
                  $event.stopPropagation();
                  updateOptionSwitch(offerCustomizationEnum.JP)
                "></p-inputSwitch>
            </div>
          </div>
        </div>
        <!-- APPAREILS NOMADES -->
        <div
          class="panelSV width-max flex flex-col"
          [ngClass]="setClassActive(nomadeProtect)"
          (click)="
            $event.preventDefault();
            $event.stopPropagation();
            setInputSwitch(offerCustomizationEnum.NP)
          "
          (keydown)="
            $event.preventDefault();
            $event.stopPropagation();
            setInputSwitch(offerCustomizationEnum.NP)
          "
          *ngIf="showNomadeProtect">
          <div class="flex m-4">
            <div class="flex bg-gray-100 justify-between items-center w-full py-4 px-6 rounded-2xl">
              <p class="textPanelOpt">
                {{ resource.offercustomization.titleMP }}
              </p>
              <p class="textBPanelOpt" [innerHTML]="customizeOfferVm.subtitleNP"></p>
            </div>
          </div>
          <div class="flex m-4 mt-0">
            <div class="flex flex-col basis-5/6">
              <!--INFOS  -->
              <p class="italic">{{ resource.infobulle.nomadeProtection1 }}</p>
            </div>
            <div class="flex flex-col basis-1/6 items-center justify-center">
              <p-inputSwitch
                [(ngModel)]="nomadeProtect"
                (click)="
                  $event.preventDefault();
                  $event.stopPropagation();
                  updateOptionSwitch(offerCustomizationEnum.NP)
                "
                (keydown)="
                  $event.preventDefault();
                  $event.stopPropagation();
                  updateOptionSwitch(offerCustomizationEnum.NP)
                "></p-inputSwitch>
            </div>
          </div>
        </div>

        <!-- VALEUR A NEUF  -->
        <div
          class="panelSV width-max flex flex-col"
          [ngClass]="setClassActive(replacementCost)"
          (click)="
            $event.preventDefault();
            $event.stopPropagation();
            setInputSwitch(offerCustomizationEnum.VAN)
          "
          (keydown)="
            $event.preventDefault();
            $event.stopPropagation();
            setInputSwitch(offerCustomizationEnum.VAN)
          "
          *ngIf="
            showVAN && currentFormule.PrimesOptions && currentFormule.PrimesOptions.ValeurANeuf
          ">
          <div class="flex m-4">
            <div class="flex w-full">
              <div
                class="flex bg-gray-100 justify-between items-center py-4 px-6 w-full rounded-2xl">
                <p class="textPanelOpt">
                  {{ resource.offercustomization.titleVAN }}
                </p>
                <p class="textBPanelOpt" [innerHTML]="customizeOfferVm.subtitleVAN"></p>
              </div>
            </div>
          </div>
          <div class="flex m-4 mt-0">
            <div class="flex basis-5/6">
              <p class="italic">{{ resource.infobulle.replacementCost }}</p>
            </div>
            <div class="flex basis-1/6 justify-center items-center flex-col">
              <p-inputSwitch
                [(ngModel)]="replacementCost"
                (click)="
                  $event.preventDefault();
                  $event.stopPropagation();
                  updateOptionSwitch(offerCustomizationEnum.VAN)
                "
                (keydown)="
                  $event.preventDefault();
                  $event.stopPropagation();
                  updateOptionSwitch(offerCustomizationEnum.VAN)
                "></p-inputSwitch>
            </div>
          </div>
        </div>

        <!-- ASSURANCE SCOLAIRE -->
        @if(currentFormule.PrimesOptions && currentFormule.PrimesOptions.AssuranceScolaire) {
        <div
          class="panelSV width-max flex flex-col"
          [ngClass]="setClassActive(schoolInsurance)"
          (click)="
            $event.preventDefault();
            $event.stopPropagation();
            setInputSwitch(offerCustomizationEnum.SI)
          "
          (keydown)="
            $event.preventDefault();
            $event.stopPropagation();
            setInputSwitch(offerCustomizationEnum.SI)
          ">
          <div class="flex m-4">
            <div class="flex bg-gray-100 justify-between items-center w-full py-4 px-6 rounded-2xl">
              <p class="textPanelOpt">
                {{ resource.offercustomization.titleSI }}
              </p>
            </div>
          </div>
          <div class="flex m-4 mt-0">
            <!-- INFOS -->
            <div class="flex basis-5/6 flex-col">
              <p class="italic">{{ resource.infobulle.schoolInsurance }}</p>
              <!-- <p class="italic">{{ resource.offercustomization.titledetailsSI }}</p> -->
              <!-- <p class="italic" [innerHTML]="">{{ resource.offercustomization.subtitleSI1 }}</p> -->
            </div>
            <div class="flex basis-1/6 my-4 justify-center">
              <p-inputSwitch
                [(ngModel)]="schoolInsurance"
                (click)="
                  $event.preventDefault();
                  $event.stopPropagation();
                  updateOptionSwitch(offerCustomizationEnum.SI)
                "
                (keydown)="
                  $event.preventDefault();
                  $event.stopPropagation();
                  updateOptionSwitch(offerCustomizationEnum.SI)
                "></p-inputSwitch>
            </div>
          </div>
        </div>
        }

        <!-- VOL -->
        <div
          class="panelSV width-max flex flex-col"
          [ngClass]="setClassActive(vlx)"
          (click)="
            $event.preventDefault();
            $event.stopPropagation();
            setInputSwitch(offerCustomizationEnum.VLX)
          "
          (keydown)="
            $event.preventDefault();
            $event.stopPropagation();
            setInputSwitch(offerCustomizationEnum.VLX)
          "
          *ngIf="currentFormule.PrimesOptions && currentFormule.PrimesOptions.Vol">
          <div class="flex m-4">
            <!-- <div class="flex w-full"> -->
            <div class="flex bg-gray-100 w-full justify-between items-center py-4 px-6 rounded-2xl">
              <p class="textPanelOpt">
                {{ resource.offercustomization.titleVOL }}
              </p>
              <p class="textBPanelOpt" [innerHTML]="customizeOfferVm.subtitleVOL"></p>
            </div>
          </div>
          <div class="flex m-4 mt-0">
            <div class="flex basis-5/6">
              <p class="italic">{{ resource.infobulle.vol }}</p>
            </div>
            <div class="flex basis-1/6 justify-center my-4">
              <p-inputSwitch
                [(ngModel)]="vlx"
                (click)="
                  $event.preventDefault();
                  $event.stopPropagation();
                  updateOptionSwitch(offerCustomizationEnum.VLX)
                "
                (keydown)="
                  $event.preventDefault();
                  $event.stopPropagation();
                  updateOptionSwitch(offerCustomizationEnum.VLX)
                "></p-inputSwitch>
            </div>
          </div>
        </div>
        <div class="mt-6 mb-4">
          <button
            pButton
            class="mx-auto my-4 button-NS width-max iconSideLabel"
            [label]="resource.nextstep.nextStep"
            icon="pi pi-arrow-right"
            iconPos="right"
            (click)="nextStep()"
            [loading]="isLoading"></button>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<div class="container mx-auto h-28 md:h-40">
  <app-footer class="footer"></app-footer>
</div>
<app-web-callback></app-web-callback>

<app-error-popup
  [show]="displayError"
  (cancel)="displayError = false"
  [title]="resource.error.oups"
  [text]="resource.error.api"></app-error-popup>

<app-error-popup
  [show]="isLoading"
  [loading]="isLoading"
  [closeable]="false"
  [text]="resource.offercustomization.loading_message"></app-error-popup>
